import { LazyQueryNetworkBoundrary } from "@/src/components/mobile/QueryNetworkBoundrary";
import React, { useCallback, useEffect, useMemo } from "react";
import { WACategoryScreenProps } from "../../WANavigation";
import { overviewWidgetSizes } from "../../utils/widgetSizes/overviewWidgetSizes";
import { getWidgetAddWidgetSizeWithinBounds } from "../../utils/useWidgetAddWidgetSizeState";
import { ScrollView } from "react-native";
import { WACategoryWidgetContainer } from "@/src/features/Storecast/Storecast/WidgetAdd/WACategoryWidgetContainer";
import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { useWACategoryLayout } from "../../utils/useWACategoryLayout";
import {
  WA_CALENDAR_OVERVIEW_PREVIEW_QUERY,
  WACalendarOverviewPreview,
} from "../../../Widgets/WidgetCalendarOverview/WACalendarOverviewPreview";
import { useQueryLoader } from "react-relay";
import { WACalendarOverviewPreviewQuery } from "../../../Widgets/WidgetCalendarOverview/__generated__/WACalendarOverviewPreviewQuery.graphql";
import { WAWidgetSizeToOverviewSize } from "../../utils/WAWidgetSizeToOverviewSize";

type Props = WACategoryScreenProps<"WACategoryCalendar">;

function InnerWACategoryCalendar(props: Props & { fetchKey: string }) {
  const intl_tokens = useIntlTokens();
  const contentContainerStyle = useWACategoryLayout();
  const [calendarSize, hasSizeWithinBounds] = useMemo(
    () =>
      getWidgetAddWidgetSizeWithinBounds({
        widgetSizes: overviewWidgetSizes,
        maxSize: props.route.params.maxSize,
      }),
    [props.route.params.maxSize]
  );
  const [previewQuery, loadPreview] =
    useQueryLoader<WACalendarOverviewPreviewQuery>(
      WA_CALENDAR_OVERVIEW_PREVIEW_QUERY
    );

  useEffect(() => {
    loadPreview({
      storecastId: props.route.params.storecastId,
      input: {
        size: WAWidgetSizeToOverviewSize(calendarSize),
        calendarIds: [],
      },
    });
  }, [calendarSize, loadPreview, props.route.params.storecastId]);

  const onAdd = useCallback(() => {
    props.navigation.navigate("WidgetAddCalendarOverview", props.route.params);
  }, [props.navigation, props.route.params]);

  return (
    <ScrollView contentContainerStyle={contentContainerStyle}>
      <WACategoryWidgetContainer
        hasSizeWithinBounds={hasSizeWithinBounds}
        size={calendarSize}
        title={intl_tokens.Calendar}
        unitSize={props.route.params.unitSize}
        onAdd={onAdd}
        addTitle={intl_tokens.Select}
        description=""
      >
        {previewQuery ? (
          <WACalendarOverviewPreview query={previewQuery} />
        ) : null}
      </WACategoryWidgetContainer>
    </ScrollView>
  );
}

export function WACategoryCalendar(props: Props) {
  return (
    <LazyQueryNetworkBoundrary>
      {(fetchKey) => <InnerWACategoryCalendar {...props} fetchKey={fetchKey} />}
    </LazyQueryNetworkBoundrary>
  );
}
